export class ListAzureFileShares200ResponseFileSharesInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "quotaGiB",
            "baseName": "quotaGiB",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "enabledProtocols",
            "baseName": "enabledProtocols",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureFileShares200ResponseFileSharesInner.attributeTypeMap;
    }
    constructor() {
    }
}
